/* HB 28.09.2026 (Stephan): Ueberschrift "Echte Kundenfotos" + zweite Loox-Bewertungszeile unterhalb der USP-Leiste
   nur zeigen, wenn das Loox-Galerie-Carousel wirklich Kundenfotos rendert. Loox baut das Carousel immer als iframe
   ein; ohne Fotos bleibt der Container 0 px hoch. Kriterium: Containerhoehe > 40 px -> Klasse hb-loox-photos auf dem
   Carousel-App-Block. Ein-/Ausblenden der Nachbarn macht custom.css (Textblock davor, Rating-Block danach).
   Die Bewertungszeile ueber dem Titel ist davon nicht betroffen. */
(function () {
  function gate() {
    document.querySelectorAll('.loox-v2-carousel-container').forEach(function (c) {
      var block = c.closest('.shopify-block') || c;
      block.classList.toggle('hb-loox-photos', c.getBoundingClientRect().height > 40);
    });
  }
  function start() {
    var cs = document.querySelectorAll('.loox-v2-carousel-container');
    if (!cs.length) return;
    gate();
    if ('ResizeObserver' in window) { var ro = new ResizeObserver(gate); cs.forEach(function (c) { ro.observe(c); }); }
    var mo = new MutationObserver(gate);
    cs.forEach(function (c) { mo.observe(c, { childList: true, subtree: true, attributes: true }); });
    var n = 0, t = setInterval(function () { gate(); if (++n > 40) clearInterval(t); }, 500); /* Fallback 20 s */
    window.addEventListener('resize', gate);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
